import React from "react";
import "./style.scss";

const Title = ({ className, children }) => <h2 className={`title ${className ? className : ""}`}>{children}</h2>;

Title.defaultProps = {
  text: "Título"
};

export default Title;
